<template>
  <div class="animated fadeIn">

    <!-- Modal que informa que la licencia del sistema no esta aceptada aun por el responsable. -->
    <ModalAlertNotAccepted />

    <!-- Modal para ver detalles de la licencia. -->
    <ModalDetailsAndConfirmation />

    <!-- Informe sonbre el estado de la licencia -->
    <div class="card card-body text-center shadow-sm" v-if="licencia != null && !isSuperAdmin && licencia.is_license_accepted == 0">
      <strong>
        <i class="fa fa-info-circle " /> El responsable debe aceptar el contrato de
        la licencia para el uso de Soluquim.

        <b-button
          v-if="userActiveInLicense"
          class="mr-3 ml-2"
          variant="outline-primary"
          @click="openModalSeeDetailsLicense"
        >
          Ver licencia
          <i class="fa fa-arrow-right" />
        </b-button>

      </strong>
    </div>

    <b-row>
      <b-col sm="12">
        <SistemasClasificacion></SistemasClasificacion>
      </b-col>
      <b-col sm="12"></b-col>
    </b-row>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {getAcls} from '../plugins/acl';
import SistemasClasificacion from './graficas/SistemasClasificacion';
import Tarjetas from './graficas/Tarjetas';
import loader from '../containers/loader';
import ModalAlertNotAccepted from './empresa/licencias/acceptLicense/ModalAlertNotAccepted.vue'
import ModalDetailsAndConfirmation from './empresa/licencias/acceptLicense/ModalDetailsAndConfirmation.vue'

export default {
  name: 'dashboard',
  data: function () {
    return {
      userResponsibleId: '',
      isSuperAdmin: false
    };
  },
  components: {
    SistemasClasificacion,
    Tarjetas,
    loader,
    ModalAlertNotAccepted,
    ModalDetailsAndConfirmation
  },
  async mounted() {
    this.setModalAcceptLicense(false);
    this.setModalDetailsLicence(false);

    this.load(true);
    var acls = getAcls();
    //this.establerIdEmpresaLicencia(acls.empresa)
    //await this.licenciasPorCaducar()

    await this.asignaEmpresaDash(acls.empresa);



    await this.setUsuario(acls.user);
    this.userResponsibleId = acls.usuario_id;



    await this.notificationsUnread()

    // verificar si la licencia del sistema esta aprobada y cargar sus datos
    const license = {
      companyId: acls.empresa,
      userActiveId: acls.usuario_id
    }
    const findRol = acls.roles.find(x => x == "superadmin");
    if (!findRol) await this.checkSystemLicenseIsApproved(license);
    else this.isSuperAdmin = true

    this.load(false);
  },
  computed: {
    ...mapState('dashboard', ['filtro', 'usuario', 'selectedGraficas', 'loading', 'estadoContratoDeLicencia']),
    ...mapState('empresa', [
      'edicionUsuario',
      'imagenCargada',
    ]),
    ...mapState('licencias', [
      'licencia',
      'modalAcceptLicense',
      'modalDetailsLicense',
    ]),
    userActiveInLicense() {
      return this.userResponsibleId == this.licencia.responsible_user_id ? true : false
    }
  },
  methods: {
    ...mapActions('empresa', ['getUsuario']),
    ...mapActions('dashboard', ['notificationsUnread']),
    ...mapActions("licencias", [
      "checkSystemLicenseIsApproved"
    ]),
    ...mapMutations('dashboard', [
      'asignaEmpresaDash',
      'setUsuario',
      'load',
    ]),
    ...mapMutations('licencias', [
      'establerIdEmpresaLicencia',
      'setModalAcceptLicense',
      'setModalDetailsLicence',
      'setIsVisibleDetailsLicensingContract',
    ]),
    openModalSeeDetailsLicense() {
      this.setIsVisibleDetailsLicensingContract('close')
      this.setModalDetailsLicence(true)
    }
  },
};
</script>
